export default superclass => class extends superclass  {

    // returns the parameters that may be altered
    // in accordance with the RULES
    getParametersToShow() {
        let effects = [... this.effects];
        for (let i in this.effects) {
            let effect = this.effects[i];
            if (effect.name === 'Effect Rack') {
                effects = [... effects, ...effect.effects, ...effect.macros.map(x => x.macroParameter)];
            }
        }
        if (this.tracks) {
            for (let i in this.tracks) {
                effects = [... effects, ...this.tracks[i].track.effects];
            }
        }

        let filter = effects.find(s => s.name === 'Filter');
        let eq8 = effects.find(s => s.name === 'EQ 8');
        let tapeDelay = effects.find(s => s.name === 'Tape Delay');
        let warp  = this.midiEffects.effects.find(s => s.name === 'Warp');
        let tidal = this.midiEffects.effects.find(s => s.name === 'Tidal');

        let parameters = [];

        if (filter) {
            parameters.push(filter.cutoffParameter);
        }

        if (tapeDelay) {
            parameters.push(tapeDelay.rateParameter);
            parameters.push(tapeDelay.wetParameter);
        }

        if (warp) {
            parameters.push(warp.loopLengthParameter);
        }

        if (tidal) {
            parameters.push(tidal.cycleParameter);
        }

        return parameters;
    }
}
